
export class ChangePasswordModel {
   username: string
   newPassword: string
   newPasswordSecond: string
}
